export default __webpack_public_path__ + "static/media/vsupitelnie.1abba0b4.pdf";